module.exports = __webpack_public_path__ + "images/Logo_six_ares1-V1-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/Logo_six_ares1-V1-1.png
// module id = 95
// module chunks = 0